import { render, staticRenderFns } from "./BannerID.vue?vue&type=template&id=6a767b88&scoped=true"
import script from "./BannerID.vue?vue&type=script&lang=js"
export * from "./BannerID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a767b88",
  null
  
)

export default component.exports